import { useAuth0 } from '@client/helperComponents/react-auth0-spa';
import { AUTH_0_SIGN_UP } from '@client/definitions/constants';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function SignUpPage() {
  const auth = useAuth0();
  const isAuthenticated = auth && auth.isAuthenticated;
  const loginWithRedirect = auth && auth.loginWithRedirect;
  const loading = auth && auth.loading;
  const navigate = useNavigate();

  useEffect(() => {
    const asyncLoginWithRedirect = async (params) => {
      await loginWithRedirect(params);
    };

    if (isAuthenticated) {
      navigate(`/`);
    }

    if (!loading && !isAuthenticated && loginWithRedirect) {
      asyncLoginWithRedirect({
        screen_hint: AUTH_0_SIGN_UP,
        appState: {
          targetUrl: '/skapa/insamling',
        },
      });
    }
  }, [isAuthenticated, loginWithRedirect, loading, navigate]);

  return null;
}

export default SignUpPage;
